import { useEffect, useEffectEvent } from 'react'

const FORM_FIELD_TAGS = new Set(['INPUT', 'SELECT', 'TEXTAREA'])

/**
 * Runs `handler` on ctrl+/ or cmd+/ anywhere on the page, except while the user
 * is typing in a form field or contentEditable region.
 *
 * The one global hotkey in the CRM. The binding lives with whichever search
 * component is mounted, so the handler mounted last wins when two are on screen
 * at once — the booking modal's concern search over the header patient search.
 */
export const useFocusSearchHotkey = (handler: (event: KeyboardEvent) => void) => {
  const onHotkey = useEffectEvent(handler)

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== '/' || !(event.ctrlKey || event.metaKey)) return
      const target = event.target as HTMLElement | null
      if (target && (FORM_FIELD_TAGS.has(target.tagName) || target.isContentEditable)) return
      onHotkey(event)
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [])
}
